// extracted by mini-css-extract-plugin
module.exports = {"socialProfileHeader":"SocialProfileHeader__socialProfileHeader__DbBrC","header":"SocialProfileHeader__header__x1rJO","subheader":"SocialProfileHeader__subheader__GEBu7"};